// helper
import { required, email, onlyNumbers } from '../../components/FormInputs/helperFunctions'
import InputText from '../../components/FormInputs/InputText'

export const FORM_FIELDS = [
  {
    name: 'name',
    // className: 'error',
    validation: required,
    component: InputText,
    placeholder: 'Name',
    title: 'Name *'
  },

  {
    name: 'company',
    // className: 'error',
    validation: required,
    component: InputText,
    placeholder: 'Company Name',
    title: 'Company Name *'
  },

  {
    name: 'title',
    component: InputText,
    placeholder: 'Title',
    title: 'Title'
  },

  {
    name: 'email',
    // className: 'error',
    validation: email,
    component: InputText,
    placeholder: 'Email',
    title: 'Email *'
  },

  {
    name: 'phone',
    // className: 'error',
    validation: onlyNumbers,
    component: InputText,
    placeholder: 'Phone Number',
    title: 'Phone Number *'
  },

  {
    name: 'address',
    // className: 'error',
    validation: required,
    component: InputText,
    placeholder: 'Address',
    title: 'Address *'
  },

  {
    name: 'inquiry',
    // className: 'error',
    validation: required,
    component: InputText,
    placeholder: 'Inquiry',
    title: 'Inquiry *'
  }
]